import React from "react";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "./styles.css";

interface MenuPageFeedbackProps {
  empty?: boolean;
  message: string;
  onRetry?: () => void;
  title: string;
}

export const MenuPageFeedback = ({
  empty = false,
  message,
  onRetry,
  title,
}: MenuPageFeedbackProps) => (
  <div
    className="menu-page-state"
    role={empty ? "status" : "alert"}
  >
    <span className="menu-page-state__icon" aria-hidden="true">
      {empty ? <InboxOutlinedIcon /> : <ErrorOutlineRoundedIcon />}
    </span>
    <h2>{title}</h2>
    <p>{message}</p>
    {onRetry && (
      <button type="button" onClick={onRetry}>
        Tentar novamente
      </button>
    )}
  </div>
);

export const MenuPageLoading = ({ label }: { label: string }) => (
  <div className="menu-page-loading" aria-busy="true" aria-label={label}>
    <Skeleton width="min(360px, 72vw)" height={38} />
    <Skeleton width="min(620px, 86vw)" height={22} />
    <div className="menu-page-loading__grid">
      <Skeleton height={190} borderRadius={15} />
      <Skeleton height={190} borderRadius={15} />
      <Skeleton height={190} borderRadius={15} />
    </div>
  </div>
);
